import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function NotAvailable() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        background: 'linear-gradient(135deg, #0f0221 0%, #1a0535 40%, #2d0a4a 100%)',
      }}
    >
      <Paper elevation={1} sx={{ maxWidth: 480, width: '100%', p: 4 }}>
        <Stack spacing={1.5}>
          <Typography variant="h5" component="h1">
            {t('notAvailable.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('notAvailable.body')}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

export default NotAvailable;
